module.exports = __webpack_public_path__ + "img/sx-poster.af83b923.png";